export default {
  edit: "author:edit",
  create: "author:create",
  delete: "author:delete",
  view: "author:view",
};
